import React,{useState} from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper } from '@mui/material';
import GeneralAction from '../panel/generalAction'


const AchievementTable = (props) => {

    return (
        <>
            {props.data ?
                <>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow className='bg-warning'>
                                    <TableCell>sl.</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Achievement</TableCell>
                                    <TableCell>Short Description</TableCell>
                                    <TableCell>Student</TableCell>
                                    <TableCell>Image</TableCell>
                                    <TableCell align="right">Date</TableCell>
                                    <TableCell align="right">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.data && props.data.map((row, index) => (
                                    <TableRow
                                        key={index + 1}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {index + 1}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.user_name}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.title}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.short_desc}
                                        </TableCell>
                                        
                                        <TableCell component="th" scope="row">
                                            {row.user_name}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {/* {row.image} */}
                                            <img src={`${process.env.REACT_APP_BACKEND}assets/achiement/${row.image}`} style={{height : 40}} />
                                        </TableCell>
                                        <TableCell align="right">{row.date}</TableCell>
                                        <TableCell align="right">
                                            <GeneralAction data={row}  handleClickOpen={props.handleClickOpen} handleDelete={props.handleDelete}
                                                typed={'achive'}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
                :
                ''
            }
        </>
    )
}

export default AchievementTable;